import {Button} from '@material-ui/core';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React from 'react';
import { useHistory } from 'react-router-dom';
import 'Users/components/UserRecovery/PasswordReset/PasswordResetExpired.sass';

const PasswordResetExpired = () => {
  const history = useHistory();

  return (
    <div className="password-reset-expired">
      <p>The password reset request has expired.</p>
      <p>Please try again.</p>
      <Button variant="contained" color="primary" onClick={() => history.push(CoreRouteConstants.LOGIN)}>
        Return to Login
      </Button>
    </div>
  );
};

export default PasswordResetExpired;
